export default "__VITE_ASSET__V3$lrOuN__"